import React from 'react'
import Img from 'gatsby-image'

const EndorsementSection = props => {
  const endorsements = [
    {
      name: 'Austin-American Statesman',
      resolutions: props.statesmanImage.resolutions,
      href:
        'https://www.statesman.com/opinion/20181019/editorial-prop-is-key-piece-to-austins-affordability-puzzle?fbclid=IwAR2zNPi1h6-6SJQZf409xTZEEbEDKNVjygDqcRAIDLcQa06Hh6Cvkt_aQvw',
    },
    {
      name: 'Austin Chronicle',
      resolutions: props.chronicleImage.resolutions,
      href:
        'https://www.austinchronicle.com/news/2018-10-19/chronicle-endorsements-city-propositions/',
    },
  ]

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col">
          <h2 className="mb-4" style={{ fontWeight: 'bold' }}>
            Endorsed By
          </h2>
        </div>
      </div>
      <div
        className="row align-items-center justify-content-center"
        style={{ textAlign: 'center' }}
      >
        {endorsements.map((endorsements, i) => (
          <div className="col-sm hover01" key={i}>
            <a href={endorsements.href} target="_blank">
              <figure>
                <Img
                  title={endorsements.name}
                  alt={endorsements.name}
                  resolutions={endorsements.resolutions}
                />
              </figure>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default EndorsementSection



// WEBPACK FOOTER //
// ./src/components/EndorsementSection.js